import React, { useMemo, useState } from "react";
import { Field } from "formik";
import { DateInput } from "../FormComponents/DateInput";
import { CTA, InputField, PhoneInputField } from "@coverme/forms";
import { SimpleMultiSelect } from "../FormComponents/SimpleMultiSelect";
import "./MyCasesFilters.scss";
import { SocialSecurityInputField } from "@coverme/forms";

export const PatientFilters = ({
    EncounterStatusFilter,
    values,
    getErrors,
    getValidationState,
    setFieldValue,
    setTimeout,
    setFieldTouched,
    users,
    uniqueProgramsList,
    onExportClicked,
    validationSchema,
    handleSubmit,
    handleReset,
    submitForm,
    isTagsEnabled,
    lookups,
}) => {
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const [showHideButtonText, setShowHideButtonText] = useState("Filter");

    function toggleFilters() {
        setIsFiltersOpen(!isFiltersOpen);
    }

    function setShowHideButton() {
        if (!isFiltersOpen) {
            setShowHideButtonText("Hide");
        } else {
            setShowHideButtonText("Filter");
        }
    }

    const tagOptions = useMemo(() => {
        if (lookups == undefined || lookups == null) {
            return [];
        }

        if (
            lookups.automatedTags == undefined ||
            lookups.automatedTags == null ||
            lookups.manualTags == undefined ||
            lookups.manualTags == null
        ) {
            return [];
        }

        let noneTag = { id: "none", tagName: "None", isAutomated: false };
        let allTags = [...lookups.automatedTags, ...lookups.manualTags, ...[noneTag]];
        return allTags.map(x => ({ label: x.tagName, value: x.id }));
    }, [lookups]);

    return (
        <>
            <div className="filter-switch-container">
                <div className="my-cases-filters__bottom">
                    <EncounterStatusFilter
                        setFieldValue={setFieldValue}
                        value={values.filterEncounter?.length > 0 ? ["Complete"] : values.EncounterStatuses}
                        name="EncounterStatuses"
                        disabled={values.filterEncounter?.length > 0}
                        onChange={e => {
                            setFieldValue("EncounterStatuses", e);
                            setTimeout(submitForm, 0);
                        }}
                    />
                </div>
                <div className="filter-switch">
                    <CTA
                        size={"medium"}
                        click={() => {
                            toggleFilters();
                            setShowHideButton();
                        }}
                        styleType={"grey-dark"}
                        style={{ marginRight: "15px" }}
                    >
                        {showHideButtonText}
                    </CTA>
                    <CTA
                        size={"medium"}
                        styleType={"grey-dark"}
                        click={onExportClicked.bind(this, values)}
                        style={{ marginRight: "23px" }}
                    >
                        Export
                    </CTA>
                </div>
            </div>
            {isFiltersOpen && (
                <div className={`my-cases-filters__detailed ${"open"}`}>
                    <div className="patient-filter-row">
                        <div className="my-cases-filters__input">
                            <Field
                                name="personCriteria.fullNameContains"
                                render={({ field }) => (
                                    <InputField
                                        id={field.name}
                                        title={"Full Name"}
                                        placeholder={"Full Name"}
                                        {...field}
                                        onBlur={e => {
                                            setFieldValue(field.name, e.currentTarget.value.toString().trim());
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div className="my-cases-filters__input">
                            <Field
                                name="lastFourOfSsn"
                                render={({ field }) => (
                                    <SocialSecurityInputField
                                        {...field}
                                        id="new_case_ssn"
                                        title={"Social Security Number"}
                                        value={field.value}
                                        changeEvent={e => {
                                            setFieldValue(field.name, e.substring(0, 9));
                                        }}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input">
                            <Field
                                name="dob"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        title={`Date of Birth`}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="patient-filter-row">
                        <div className="my-cases-filters__input">
                            <Field
                                name="phoneNumber"
                                render={({ field }) => (
                                    <PhoneInputField
                                        {...field}
                                        title={"Phone Number"}
                                        id="phoneNumber"
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        changeEvent={e => {
                                            setFieldValue(field.name, e);
                                        }}
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input">
                            <Field
                                name="personCriteria.Mrn"
                                render={({ field }) => (
                                    <InputField
                                        id={field.name}
                                        title={"MRN"}
                                        placeholder={"MRN"}
                                        {...field}
                                        onBlur={e => {
                                            setFieldValue(field.name, e.currentTarget.value.toString().trim());
                                        }}
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input">
                            <Field
                                name="filterUCI"
                                render={({ field }) => (
                                    <InputField
                                        {...field}
                                        type={"number"}
                                        id={field.name}
                                        title={"UCI"}
                                        placeholder={"UCI"}
                                        validState={getValidationState(field)}
                                        errorMessage={getErrors(field)}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="patient-filter-row">
                        <div className="my-cases-filters__input">
                            <Field
                                name="ServiceStartDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        title={`Service Start Date Between`}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input" style={{ marginTop: "37px" }}>
                            <Field
                                name="ServiceEndDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input">
                            <Field
                                name="creatorUsers"
                                render={({ field }) => (
                                    <SimpleMultiSelect
                                        name={field.name}
                                        setFieldValue={setFieldValue}
                                        setFieldTouched={setFieldTouched}
                                        id={field.name}
                                        title={"Users"}
                                        options={users}
                                        {...field}
                                    />
                                )}
                            />
                        </div>
                    </div>

                    {isTagsEnabled && (
                        <div className="patient-filter-row">
                            <div className="my-cases-filters__input">
                                <Field
                                    name="tags"
                                    render={({ field }) => (
                                        <SimpleMultiSelect
                                            name={field.name}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            id={field.name}
                                            title={"Tags"}
                                            options={tagOptions}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    )}

                    <div className="my-cases-filters__submit">
                        <button
                            className="reset_button"
                            type="reset"
                            onClick={() => {
                                handleReset();
                                handleSubmit();
                            }}
                        >
                            Reset All
                        </button>
                    </div>
                    <div className="my-cases-filters__submit">
                        <CTA
                            size={"medium"}
                            styleType={"blue"}
                            click={() => {
                                handleSubmit(values);
                            }}
                        >
                            Submit
                        </CTA>
                    </div>
                </div>
            )}
        </>
    );
};
